var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeySuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3450_1132)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 54,
    transform: "matrix(-1 0 0 1 108 2)",
    fill: "#C0B3B3",
    stroke: "#C0B3B3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9318 71.3121C49.0518 71.3121 48.6118 70.8721 48.6118 69.9921V41.3921C48.6118 40.7467 49.1985 40.4241 50.3718 40.4241H50.7238C51.8971 40.4241 52.4838 40.7467 52.4838 41.3921V67.9681H64.5838C65.1705 67.9681 65.4638 68.4081 65.4638 69.2881V69.9921C65.4638 70.8721 65.1705 71.3121 64.5838 71.3121H49.9318Z",
    fill: "#C0B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 31.6666C42.1198 31.6666 31.6665 42.12 31.6665 55C31.6665 67.88 42.1198 78.3333 54.9998 78.3333C67.8798 78.3333 78.3332 67.88 78.3332 55C78.3332 42.12 67.8798 31.6666 54.9998 31.6666ZM48.6765 65.01L40.2998 56.6333C39.3898 55.7233 39.3898 54.2533 40.2998 53.3433C41.2098 52.4333 42.6798 52.4333 43.5898 53.3433L50.3332 60.0633L66.3865 44.01C67.2965 43.1 68.7665 43.1 69.6765 44.01C70.5865 44.92 70.5865 46.39 69.6765 47.3L51.9665 65.01C51.0798 65.92 49.5865 65.92 48.6765 65.01Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3450_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySuccess);
export default __webpack_public_path__ + "static/media/key-success.f7d3353713025423f4e86b66dddfafbe.svg";
export { ForwardRef as ReactComponent };